module.exports = __webpack_public_path__ + "img/arrow_right_square.9c57341b.svg";